import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { submitSteps } from "@/mocks/site";

export default function ProcessSection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20" aria-labelledby="process-title">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          id="process-title"
          eyebrow="投稿流程"
          title="从你按下发送，到线索被看见"
          desc="全程四步，没有中间商，也不会有任何人要求你提供真实身份。"
          align="center"
        />

        <ol className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-5">
          {submitSteps.map((item, index) => (
            <li key={item.step} className="relative flex flex-col">
              <div className="flex items-center gap-3">
                <span className="w-12 h-12 rounded-full bg-foreground-950 text-background-50 flex items-center justify-center font-heading text-lg font-bold shrink-0">
                  {item.step}
                </span>
                {index < submitSteps.length - 1 && (
                  <span className="hidden lg:block flex-1 h-px bg-background-300"></span>
                )}
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/submit"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-primary-500 text-background-50 text-sm font-label font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-send-plane-fill w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
            开始投稿
          </Link>
          <Link
            to="/faq"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border border-background-300 text-foreground-800 text-sm font-label font-medium whitespace-nowrap hover:border-foreground-400 transition-colors cursor-pointer"
          >
            先看看常见问题
          </Link>
        </div>
      </div>
    </section>
  );
}